module.exports = __webpack_public_path__ + "media/categories/4013-1c111a66.svg";